const state = {
  loggedIn: false,
  scopes: []
}

const mutations = {
  auth_authenticated (state, payload) {
    state.loggedIn = true
    state.scopes = payload
  },
  auth_destroyed (state) {
    state.loggedIn = false
    state.scopes = []
  }
}

export default {state, mutations}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js